import { useSettings } from '@wu/widget-core';
import { MOBILE_WIDTH, TABLET_WIDTH } from '../../constants';

export const useSizeResult = (
  width,
  withCaption = false,
  relativeLogoSize = 100
) => {
  const {
    captionEnabled,
    captionType,
    logoSizeMobile,
    logoSizeTablet,
    logoSize,
    minCaptionWidth
  } = useSettings();

  const sizeMultiplier = relativeLogoSize / 100;
  const captionAvailable = captionEnabled && captionType === 'below';

  const getValue = (logoSize) => {
    return captionAvailable && withCaption
      ? Math.max(minCaptionWidth, logoSize) * sizeMultiplier
      : logoSize * sizeMultiplier;
  };

  if (width <= MOBILE_WIDTH) {
    return getValue(logoSizeMobile);
  }

  if (width <= TABLET_WIDTH) {
    return getValue(logoSizeTablet);
  }

  return getValue(logoSize);
};
